import { adminCall, adminGet } from '../../../api/adminCall';

export async function getPlatformTextableSettings() {
  return adminGet('/api/admin/platform/textable');
}

export async function setPlatformTextableSettings(payload) {
  const data = await adminCall('/api/admin/platform/textable', payload || {});
  if (!data?.success) throw new Error(data?.error || 'Failed to save Textable settings');
  return data;
}

export async function testPlatformTextableSettings({ to } = {}) {
  const data = await adminCall('/api/admin/platform/textable/test', to ? { to } : {});
  if (!data?.success) throw new Error(data?.error || 'Textable test failed');
  return data;
}

export async function clearPlatformTextableSettings() {
  const data = await adminCall('/api/admin/platform/textable/clear');
  if (!data?.success) throw new Error(data?.error || 'Failed to disconnect Textable');
  return data;
}
